Array.prototype.flat||Object.defineProperty(Array.prototype,"flat",{configurable:!0,value:function r(){var t=isNaN(arguments[0])?1:Number(arguments[0]);return t?Array.prototype.reduce.call(this,function(a,e){return Array.isArray(e)?a.push.apply(a,r.call(e,t-1)):a.push(e),a},[]):Array.prototype.slice.call(this)},writable:!0}),Array.prototype.flatMap||Object.defineProperty(Array.prototype,"flatMap",{configurable:!0,value:function(r){return Array.prototype.map.apply(this,arguments).flat()},writable:!0});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var TaxMode;
(function (TaxMode) {
    TaxMode["Flat"] = "FLAT";
    TaxMode["Progressive"] = "PROGRESSIVE";
})(TaxMode || (TaxMode = {}));

/*
 *  big.js v6.0.1
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2020 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */


/************************************** EDITABLE DEFAULTS *****************************************/


  // The default values below must be integers within the stated ranges.

  /*
   * The maximum number of decimal places (DP) of the results of operations involving division:
   * div and sqrt, and pow with negative exponents.
   */
var DP = 20,          // 0 to MAX_DP

  /*
   * The rounding mode (RM) used when rounding to the above decimal places.
   *
   *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
   *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
   *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
   *  3  Away from zero.                                  (ROUND_UP)
   */
  RM = 1,             // 0, 1, 2 or 3

  // The maximum value of DP and Big.DP.
  MAX_DP = 1E6,       // 0 to 1000000

  // The maximum magnitude of the exponent argument to the pow method.
  MAX_POWER = 1E6,    // 1 to 1000000

  /*
   * The negative exponent (NE) at and beneath which toString returns exponential notation.
   * (JavaScript numbers: -7)
   * -1000000 is the minimum recommended exponent value of a Big.
   */
  NE = -7,            // 0 to -1000000

  /*
   * The positive exponent (PE) at and above which toString returns exponential notation.
   * (JavaScript numbers: 21)
   * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
   */
  PE = 21,            // 0 to 1000000

  /*
   * When true, an error will be thrown if a primitive number is passed to the Big constructor,
   * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
   * primitive number without a loss of precision.
   */
  STRICT = false,     // true or false


/**************************************************************************************************/


  // Error messages.
  NAME = '[big.js] ',
  INVALID = NAME + 'Invalid ',
  INVALID_DP = INVALID + 'decimal places',
  INVALID_RM = INVALID + 'rounding mode',
  DIV_BY_ZERO = NAME + 'Division by zero',

  // The shared prototype object.
  P = {},
  UNDEFINED = void 0,
  NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


/*
 * Create and return a Big constructor.
 */
function _Big_() {

  /*
   * The Big constructor and exported function.
   * Create and return a new instance of a Big number object.
   *
   * n {number|string|Big} A numeric value.
   */
  function Big(n) {
    var x = this;

    // Enable constructor usage without new.
    if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);

    // Duplicate.
    if (n instanceof Big) {
      x.s = n.s;
      x.e = n.e;
      x.c = n.c.slice();
    } else {
      if (typeof n !== 'string') {
        if (Big.strict === true) {
          throw TypeError(INVALID + 'number');
        }

        // Minus zero?
        n = n === 0 && 1 / n < 0 ? '-0' : String(n);
      }

      parse(x, n);
    }

    // Retain a reference to this Big constructor.
    // Shadow Big.prototype.constructor which points to Object.
    x.constructor = Big;
  }

  Big.prototype = P;
  Big.DP = DP;
  Big.RM = RM;
  Big.NE = NE;
  Big.PE = PE;
  Big.strict = STRICT;

  return Big;
}


/*
 * Parse the number or string value passed to a Big constructor.
 *
 * x {Big} A Big number instance.
 * n {number|string} A numeric value.
 */
function parse(x, n) {
  var e, i, nl;

  if (!NUMERIC.test(n)) {
    throw Error(INVALID + 'number');
  }

  // Determine sign.
  x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

  // Decimal point?
  if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

  // Exponential form?
  if ((i = n.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +n.slice(i + 1);
    n = n.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = n.length;
  }

  nl = n.length;

  // Determine leading zeros.
  for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

  if (i == nl) {

    // Zero.
    x.c = [x.e = 0];
  } else {

    // Determine trailing zeros.
    for (; nl > 0 && n.charAt(--nl) == '0';);
    x.e = e - i - 1;
    x.c = [];

    // Convert string to array of digits without leading/trailing zeros.
    for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
  }

  return x;
}


/*
 * Round Big x to a maximum of sd significant digits using rounding mode rm.
 *
 * x {Big} The Big to round.
 * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
 * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 * [more] {boolean} Whether the result of division was truncated.
 */
function round$1(x, sd, rm, more) {
  var xc = x.c;

  if (rm === UNDEFINED) rm = Big.RM;
  if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
    throw Error(INVALID_RM);
  }

  if (sd < 1) {
    more =
      rm === 3 && (more || !!xc[0]) || sd === 0 && (
      rm === 1 && xc[0] >= 5 ||
      rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))
    );

    xc.length = 1;

    if (more) {

      // 1, 0.1, 0.01, 0.001, 0.0001 etc.
      x.e = x.e - sd + 1;
      xc[0] = 1;
    } else {

      // Zero.
      xc[0] = x.e = 0;
    }
  } else if (sd < xc.length) {

    // xc[sd] is the digit after the digit that may be rounded up.
    more =
      rm === 1 && xc[sd] >= 5 ||
      rm === 2 && (xc[sd] > 5 || xc[sd] === 5 &&
        (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) ||
      rm === 3 && (more || !!xc[0]);

    // Remove any digits after the required precision.
    xc.length = sd--;

    // Round up?
    if (more) {

      // Rounding up may mean the previous digit has to be rounded up.
      for (; ++xc[sd] > 9;) {
        xc[sd] = 0;
        if (!sd--) {
          ++x.e;
          xc.unshift(1);
        }
      }
    }

    // Remove trailing zeros.
    for (sd = xc.length; !xc[--sd];) xc.pop();
  }

  return x;
}


/*
 * Return a string representing the value of Big x in normal or exponential notation.
 * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
 */
function stringify(x, doExponential, isNonzero) {
  var e = x.e,
    s = x.c.join(''),
    n = s.length;

  // Exponential notation?
  if (doExponential) {
    s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

  // Normal notation.
  } else if (e < 0) {
    for (; ++e;) s = '0' + s;
    s = '0.' + s;
  } else if (e > 0) {
    if (++e > n) {
      for (e -= n; e--;) s += '0';
    } else if (e < n) {
      s = s.slice(0, e) + '.' + s.slice(e);
    }
  } else if (n > 1) {
    s = s.charAt(0) + '.' + s.slice(1);
  }

  return x.s < 0 && isNonzero ? '-' + s : s;
}


// Prototype/instance methods


/*
 * Return a new Big whose value is the absolute value of this Big.
 */
P.abs = function () {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};


/*
 * Return 1 if the value of this Big is greater than the value of Big y,
 *       -1 if the value of this Big is less than the value of Big y, or
 *        0 if they have the same value.
 */
P.cmp = function (y) {
  var isneg,
    x = this,
    xc = x.c,
    yc = (y = new x.constructor(y)).c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  isneg = i < 0;

  // Compare exponents.
  if (k != l) return k > l ^ isneg ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = -1; ++i < j;) {
    if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
  }

  // Compare lengths.
  return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};


/*
 * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
 * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.div = function (y) {
  var x = this,
    Big = x.constructor,
    a = x.c,                  // dividend
    b = (y = new Big(y)).c,   // divisor
    k = x.s == y.s ? 1 : -1,
    dp = Big.DP;

  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }

  // Divisor is zero?
  if (!b[0]) {
    throw Error(DIV_BY_ZERO);
  }

  // Dividend is 0? Return +-0.
  if (!a[0]) return new Big(k * 0);

  var bl, bt, n, cmp, ri,
    bz = b.slice(),
    ai = bl = b.length,
    al = a.length,
    r = a.slice(0, bl),   // remainder
    rl = r.length,
    q = y,                // quotient
    qc = q.c = [],
    qi = 0,
    p = dp + (q.e = x.e - y.e) + 1;    // precision of the result

  q.s = k;
  k = p < 0 ? 0 : p;

  // Create version of divisor with leading zero.
  bz.unshift(0);

  // Add zeros to make remainder as long as divisor.
  for (; rl++ < bl;) r.push(0);

  do {

    // n is how many times the divisor goes into current remainder.
    for (n = 0; n < 10; n++) {

      // Compare divisor and remainder.
      if (bl != (rl = r.length)) {
        cmp = bl > rl ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl;) {
          if (b[ri] != r[ri]) {
            cmp = b[ri] > r[ri] ? 1 : -1;
            break;
          }
        }
      }

      // If divisor < remainder, subtract divisor from remainder.
      if (cmp < 0) {

        // Remainder can't be more than 1 digit longer than divisor.
        // Equalise lengths using divisor with extra leading zero?
        for (bt = rl == bl ? b : bz; rl;) {
          if (r[--rl] < bt[rl]) {
            ri = rl;
            for (; ri && !r[--ri];) r[ri] = 9;
            --r[ri];
            r[rl] += 10;
          }
          r[rl] -= bt[rl];
        }

        for (; !r[0];) r.shift();
      } else {
        break;
      }
    }

    // Add the digit n to the result array.
    qc[qi++] = cmp ? n : ++n;

    // Update the remainder.
    if (r[0] && cmp) r[rl] = a[ai] || 0;
    else r = [a[ai]];

  } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

  // Leading zero? Do not remove if result is simply zero (qi == 1).
  if (!qc[0] && qi != 1) {

    // There can't be more than one zero.
    qc.shift();
    q.e--;
    p--;
  }

  // Round?
  if (qi > p) round$1(q, p, Big.RM, r[0] !== UNDEFINED);

  return q;
};


/*
 * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
 */
P.eq = function (y) {
  return this.cmp(y) === 0;
};


/*
 * Return true if the value of this Big is greater than the value of Big y, otherwise return
 * false.
 */
P.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
 * return false.
 */
P.gte = function (y) {
  return this.cmp(y) > -1;
};


/*
 * Return true if the value of this Big is less than the value of Big y, otherwise return false.
 */
P.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
 * return false.
 */
P.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return a new Big whose value is the value of this Big minus the value of Big y.
 */
P.minus = P.sub = function (y) {
  var i, j, t, xlty,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  // Signs differ?
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }

  var xc = x.c.slice(),
    xe = x.e,
    yc = y.c,
    ye = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) {

    // y is non-zero? x is non-zero? Or both are zero.
    return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
  }

  // Determine which is the bigger number. Prepend zeros to equalise exponents.
  if (a = xe - ye) {

    if (xlty = a < 0) {
      a = -a;
      t = xc;
    } else {
      ye = xe;
      t = yc;
    }

    t.reverse();
    for (b = a; b--;) t.push(0);
    t.reverse();
  } else {

    // Exponents equal. Check digit by digit.
    j = ((xlty = xc.length < yc.length) ? xc : yc).length;

    for (a = b = 0; b < j; b++) {
      if (xc[b] != yc[b]) {
        xlty = xc[b] < yc[b];
        break;
      }
    }
  }

  // x < y? Point xc to the array of the bigger number.
  if (xlty) {
    t = xc;
    xc = yc;
    yc = t;
    y.s = -y.s;
  }

  /*
   * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
   * needs to start at yc.length.
   */
  if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

  // Subtract yc from xc.
  for (b = i; j > a;) {
    if (xc[--j] < yc[j]) {
      for (i = j; i && !xc[--i];) xc[i] = 9;
      --xc[i];
      xc[j] += 10;
    }

    xc[j] -= yc[j];
  }

  // Remove trailing zeros.
  for (; xc[--b] === 0;) xc.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xc[0] === 0;) {
    xc.shift();
    --ye;
  }

  if (!xc[0]) {

    // n - n = +0
    y.s = 1;

    // Result must be zero.
    xc = [ye = 0];
  }

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a new Big whose value is the value of this Big modulo the value of Big y.
 */
P.mod = function (y) {
  var ygtx,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  if (!y.c[0]) {
    throw Error(DIV_BY_ZERO);
  }

  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;

  if (ygtx) return new Big(x);

  a = Big.DP;
  b = Big.RM;
  Big.DP = Big.RM = 0;
  x = x.div(y);
  Big.DP = a;
  Big.RM = b;

  return this.minus(x.times(y));
};


/*
 * Return a new Big whose value is the value of this Big plus the value of Big y.
 */
P.plus = P.add = function (y) {
  var t,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  // Signs differ?
  if (a != b) {
    y.s = -b;
    return x.minus(y);
  }

  var xe = x.e,
    xc = x.c,
    ye = y.e,
    yc = y.c;

  // Either zero? y is non-zero? x is non-zero? Or both are zero.
  if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);

  xc = xc.slice();

  // Prepend zeros to equalise exponents.
  // Note: reverse faster than unshifts.
  if (a = xe - ye) {
    if (a > 0) {
      ye = xe;
      t = yc;
    } else {
      a = -a;
      t = xc;
    }

    t.reverse();
    for (; a--;) t.push(0);
    t.reverse();
  }

  // Point xc to the longer array.
  if (xc.length - yc.length < 0) {
    t = yc;
    yc = xc;
    xc = t;
  }

  a = yc.length;

  // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
  for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;

  // No need to check for zero, as +x + +y != 0 && -x + -y != 0

  if (b) {
    xc.unshift(b);
    ++ye;
  }

  // Remove trailing zeros.
  for (a = xc.length; xc[--a] === 0;) xc.pop();

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a Big whose value is the value of this Big raised to the power n.
 * If n is negative, round to a maximum of Big.DP decimal places using rounding
 * mode Big.RM.
 *
 * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */
P.pow = function (n) {
  var x = this,
    one = new x.constructor(1),
    y = one,
    isneg = n < 0;

  if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
    throw Error(INVALID + 'exponent');
  }

  if (isneg) n = -n;

  for (;;) {
    if (n & 1) y = y.times(x);
    n >>= 1;
    if (!n) break;
    x = x.times(x);
  }

  return isneg ? one.div(y) : y;
};


/*
 * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
 * significant digits using rounding mode rm, or Big.RM if rm is not specified.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.prec = function (sd, rm) {
  if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
    throw Error(INVALID + 'precision');
  }
  return round$1(new this.constructor(this), sd, rm);
};


/*
 * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
 * using rounding mode rm, or Big.RM if rm is not specified.
 * If dp is negative, round to an integer which is a multiple of 10**-dp.
 * If dp is not specified, round to 0 decimal places.
 *
 * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.round = function (dp, rm) {
  if (dp === UNDEFINED) dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  return round$1(new this.constructor(this), dp + this.e + 1, rm);
};


/*
 * Return a new Big whose value is the square root of the value of this Big, rounded, if
 * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.sqrt = function () {
  var r, c, t,
    x = this,
    Big = x.constructor,
    s = x.s,
    e = x.e,
    half = new Big(0.5);

  // Zero?
  if (!x.c[0]) return new Big(x);

  // Negative?
  if (s < 0) {
    throw Error(NAME + 'No square root');
  }

  // Estimate.
  s = Math.sqrt(x + '');

  // Math.sqrt underflow/overflow?
  // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
  if (s === 0 || s === 1 / 0) {
    c = x.c.join('');
    if (!(c.length + e & 1)) c += '0';
    s = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
  } else {
    r = new Big(s);
  }

  e = r.e + (Big.DP += 4);

  // Newton-Raphson iteration.
  do {
    t = r;
    r = half.times(t.plus(x.div(t)));
  } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

  return round$1(r, (Big.DP -= 4) + r.e + 1, Big.RM);
};


/*
 * Return a new Big whose value is the value of this Big times the value of Big y.
 */
P.times = P.mul = function (y) {
  var c,
    x = this,
    Big = x.constructor,
    xc = x.c,
    yc = (y = new Big(y)).c,
    a = xc.length,
    b = yc.length,
    i = x.e,
    j = y.e;

  // Determine sign of result.
  y.s = x.s == y.s ? 1 : -1;

  // Return signed 0 if either 0.
  if (!xc[0] || !yc[0]) return new Big(y.s * 0);

  // Initialise exponent of result as x.e + y.e.
  y.e = i + j;

  // If array xc has fewer digits than yc, swap xc and yc, and lengths.
  if (a < b) {
    c = xc;
    xc = yc;
    yc = c;
    j = a;
    a = b;
    b = j;
  }

  // Initialise coefficient array of result with zeros.
  for (c = new Array(j = a + b); j--;) c[j] = 0;

  // Multiply.

  // i is initially xc.length.
  for (i = b; i--;) {
    b = 0;

    // a is yc.length.
    for (j = a + i; j > i;) {

      // Current sum of products at this digit position, plus carry.
      b = c[j] + yc[i] * xc[j - i - 1] + b;
      c[j--] = b % 10;

      // carry
      b = b / 10 | 0;
    }

    c[j] = b;
  }

  // Increment result exponent if there is a final carry, otherwise remove leading zero.
  if (b) ++y.e;
  else c.shift();

  // Remove trailing zeros.
  for (i = c.length; !c[--i];) c.pop();
  y.c = c;

  return y;
};


/*
 * Return a string representing the value of this Big in exponential notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.toExponential = function (dp, rm) {
  var x = this,
    n = x.c[0];

  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round$1(new x.constructor(x), ++dp, rm);
    for (; x.c.length < dp;) x.c.push(0);
  }

  return stringify(x, true, !!n);
};


/*
 * Return a string representing the value of this Big in normal notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 */
P.toFixed = function (dp, rm) {
  var x = this,
    n = x.c[0];

  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round$1(new x.constructor(x), dp + x.e + 1, rm);

    // x.e may have changed if the value is rounded up.
    for (dp = dp + x.e + 1; x.c.length < dp;) x.c.push(0);
  }

  return stringify(x, false, !!n);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Omit the sign for negative zero.
 */
P.toJSON = P.toString = function () {
  var x = this,
    Big = x.constructor;
  return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
};


/*
 * Return the value of this Big as a primitve number.
 */
P.toNumber = function () {
  var n = Number(stringify(this, true, true));
  if (this.constructor.strict === true && !this.eq(n.toString())) {
    throw Error(NAME + 'Imprecise conversion');
  }
  return n;
};


/*
 * Return a string representing the value of this Big rounded to sd significant digits using
 * rounding mode rm, or Big.RM if rm is not specified.
 * Use exponential notation if sd is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.toPrecision = function (sd, rm) {
  var x = this,
    Big = x.constructor,
    n = x.c[0];

  if (sd !== UNDEFINED) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + 'precision');
    }
    x = round$1(new Big(x), sd, rm);
    for (; x.c.length < sd;) x.c.push(0);
  }

  return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Include the sign for negative zero.
 */
P.valueOf = function () {
  var x = this,
    Big = x.constructor;
  if (Big.strict === true) {
    throw Error(NAME + 'valueOf disallowed');
  }
  return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
};


// Export


var Big = _Big_();

function add(a, b) {
    return Big(a).plus(b).toNumber();
}
function subtract(a, b) {
    return Big(a).minus(b).toNumber();
}
function multiply(a, b) {
    return Big(a).mul(b).toNumber();
}
function round(a, dp) {
    return Big(a).round(dp).toNumber();
}
function divide(a, b) {
    return Big(a).div(b).toNumber();
}
function factorial(n) {
    return n ? multiply(n, factorial(n - 1)) : 1;
}
function multiplyAll(numbers) {
    return numbers.reduce(function (acc, number) { return multiply(acc, number); }, 1);
}

var applyTax = function (base, rate, inverse) {
    if (inverse) {
        var tax = multiply(base, rate);
        return subtract(base, tax);
    }
    return divide(base, rate + 1);
};
var getTax = function (base, rate, inverse) {
    return subtract(base, applyTax(base, rate, inverse));
};
var getBonus = function (base, percentage, roundToRealMoneyAmounts) {
    var bonus = multiply(base, divide(percentage, 100));
    return roundToRealMoneyAmounts ? round(bonus, 2) : bonus;
};
var arrayIndices = function (arr) {
    return arr.map(function (i, index) { return index; });
};

function calculateBracketBaseFlat(base, min, max) {
    if (base <= min) {
        return 0;
    }
    if (max === undefined) {
        return base;
    }
    return base <= max ? base : 0;
}
function calculateBracketBaseProgressive(base, min, max) {
    if (max === undefined) {
        return base > min ? base - min : 0;
    }
    if (base <= min) {
        return 0;
    }
    var bracketLimit = max - min;
    var bracketOverlap = base - min;
    return bracketOverlap <= bracketLimit ? bracketOverlap : bracketLimit;
}
/*
 Returns the amount which is taxable inside the given bracket.
 Bracket is defined with a min and max value.
 */
function calculateBracketBase(base, taxMode, min, max) {
    // In Flat Tax mode if the base goes over the threshold the whole amount is calculated
    // in the next bracket and the current bracket is calculated with 0 base
    if (taxMode === TaxMode.Flat) {
        return calculateBracketBaseFlat(base, min, max);
    }
    // Progressive Tax Mode
    return calculateBracketBaseProgressive(base, min, max);
}
/*
1. All tax brackets need to have threshold defined, except the last bracket
2. Last bracket should nave no threshold defined
3. Tax brackets need to be sorted by thresholds ASC
 Returns true if Valid,
 Throws error if Invalid
 */
function validateTaxBrackets(brackets) {
    if (!brackets || brackets.length === 0) {
        throw new Error('Brackets cannot be empty');
    }
    for (var i = 0; i < brackets.length; i++) {
        var bracket = brackets[i];
        var isLastBracket = i === brackets.length - 1;
        // check if it's the last bracket && it has a threshold
        if (isLastBracket && bracket.threshold !== undefined) {
            throw new Error('Tax Brackets Invalid: Last bracket cannot have a threshold');
        }
        // for all the brackets except the last one check they have a threshold defined
        if (!isLastBracket) {
            if (bracket.threshold === undefined) {
                throw new Error("Tax Brackets Invalid: Bracket [" + i + "] cannot have undefined threshold");
            }
            // check if the bracket threshold is higher than the previous bracket
            // exclude the first bracket
            if (i > 0) {
                var previousBracket = brackets[i - 1];
                if (bracket.threshold < previousBracket.threshold) {
                    throw new Error("Tax Brackets Invalid: Bracket [" + i + "] cannot have lower threshold than the Bracket [" + (i - 1) + "]");
                }
            }
        }
    }
    return true;
}
/*
    Responsible for calculating taxes per bracket given the base, brackets and tax mode.
    IMPORTANT: It doesn't do any rounding.
 */
function calculateTaxBrackets(base, brackets, mode) {
    return brackets.map(function (bracket, index) {
        var prevThreshold = index !== 0 ? brackets[index - 1].threshold : 0;
        var bracketBase = calculateBracketBase(base, mode, prevThreshold || 0, bracket.threshold);
        return __assign(__assign({}, bracket), { amount: getTax(bracketBase, bracket.rate, true) });
    });
}
function distributeProgressiveTaxToBrackets(totalTax, brackets) {
    return mapBracketsToMinMax(brackets).map(function (bracket) {
        var maxTax = bracketMaxTax(bracket.rate, bracket.min, bracket.max);
        var amount = maxTax && maxTax < totalTax ? maxTax : totalTax;
        totalTax = subtract(totalTax, amount);
        return __assign({ rate: bracket.rate, amount: amount || 0 }, (!!bracket.max && { threshold: bracket.max }));
    });
}
function distributeFlatTaxToBrackets(totalTax, brackets) {
    return brackets.map(function (bracket) {
        var maxTax = bracket.threshold ? multiply(bracket.threshold, bracket.rate) : null;
        var amount = maxTax !== null && totalTax > maxTax ? 0 : totalTax;
        totalTax = subtract(totalTax, amount);
        return __assign(__assign({}, bracket), { amount: amount || 0 });
    });
}
function bracketMaxTax(rate, min, max) {
    if (!max) {
        return undefined;
    }
    return multiply(rate, subtract(max, min));
}
function mapBracketsToMinMax(brackets) {
    return brackets.map(function (bracket, index) {
        var prevThreshold = index !== 0 ? brackets[index - 1].threshold : 0;
        var min = prevThreshold || 0;
        return __assign(__assign({}, bracket), { min: min, max: bracket.threshold });
    });
}
function getTotalTaxForSystemTicket(systems) {
    return systems.reduce(function (sum, combination) {
        return add(sum, combination.tax.totalTax);
    }, 0);
}
function getMaxTax(maxWin, taxBrackets) {
    return maxWin * taxBrackets[taxBrackets.length - 1].rate;
}
var winTaxBracketsDtoRo = '0|1';
/**
 * Returns true if format of win tax is valid.
 * winTax format is "number|(number|)* number" numbers are separated by |
 * @param winTax
 */
function isWinTaxValid(winTax) {
    if (winTax[0] === '|' || winTax[winTax.length - 1] === '|') {
        return false;
    }
    for (var i = 0; i < winTax.length; i++) {
        var c = winTax[i];
        if (i > 0 && c === '|' && c === winTax[i - 1]) {
            return false;
        }
        if (!(c >= '0' && c <= '9') && c !== '|') {
            return false;
        }
    }
    return true;
}
/**
 * Check if limits are ordered ascending (odd indexes and even indexes values should)
 * limits[4] > limits[2] > limits[0] and limits[5] > limits[3] > limits[1] should be valid
 * @param limits
 */
function areTaxLimitsValid(limits) {
    if (limits.length === 0 || limits.length % 2 !== 1) {
        return false;
    }
    if (limits[0] < 0) {
        return false;
    }
    if (limits.length > 1 && limits[1] < 0) {
        return false;
    }
    for (var i = 2; i < limits.length; i++) {
        if (limits[i - 2] >= limits[i]) {
            return false;
        }
    }
    return true;
}
function getLimits(winTaxBracketsDto) {
    if (!isWinTaxValid(winTaxBracketsDto)) {
        throw new Error('winTax is not valid');
    }
    var limits = winTaxBracketsDto.split('|').map(parseFloat);
    // Because winTaxBrakcetsDto in PL returnSiteParams doesn't start from zero
    if (limits[0]) {
        limits = __spreadArray([0], __read(limits));
    }
    else {
        limits = limits.slice(1);
    }
    if (!areTaxLimitsValid(limits)) {
        throw new Error('Win tax limits are not valid');
    }
    return limits;
}
function getTaxBrackets(winTaxBrakcetsDto) {
    if (!winTaxBrakcetsDto || winTaxBrakcetsDto === winTaxBracketsDtoRo) {
        return [{
                rate: 0,
            }];
    }
    var limits = getLimits(winTaxBrakcetsDto);
    var brackets = [];
    for (var i = 0; i < limits.length; i += 2) {
        brackets.push(__assign({ rate: limits[i] / 100 }, (limits[i + 1] && { threshold: limits[i + 1] })));
    }
    return brackets;
}
function roundTotalTaxes(taxes, totalTaxRoundingAmount) {
    return __assign(__assign({}, taxes), { totalTax: round(taxes.totalTax, totalTaxRoundingAmount) });
}

var TaxBase;
(function (TaxBase) {
    TaxBase["Base"] = "BASE";
    TaxBase["BaseMinusStake"] = "BASE_MINUS_STAKE";
})(TaxBase || (TaxBase = {}));

var _a;
/*
    Responsible for calculating taxes, given the base amount, tax brackets and config.
    1. Validates the inputs
    2. Calculates taxes by brackets
    3. Adds up bracket tax to get totalTax
    4. Rounds up totalTax
 */
function calculateTaxes(base, brackets, config) {
    if (base < 0) {
        // if taxable base is less than zero than the taxes should be 0
        return {
            totalTax: 0,
            brackets: brackets.map(function (i) { return (__assign(__assign({}, i), { amount: 0 })); }),
        };
    }
    // validate brackets
    validateTaxBrackets(brackets);
    // calculate brackets
    var calculatedBrackets = calculateTaxBrackets(base, brackets, config.taxMode);
    // calculate total tax
    var totalTax = calculatedBrackets.reduce(function (a, i) { return add(a, i.amount); }, 0);
    var roundedTotalTax = round(totalTax, config.totalTaxDecimals);
    // apply special rule to each bracket amount, saying that if roundedTotalTax === 0 all brackets need to be 0
    return {
        brackets: calculatedBrackets.map(function (i) { return (__assign(__assign({}, i), { amount: roundedTotalTax === 0
                ? 0
                : round(i.amount, config.bracketTaxDecimals) })); }),
        totalTax: roundedTotalTax,
    };
}
var taxBaseMethodMapper = (_a = {},
    _a[TaxBase.Base] = function (base) { return base; },
    _a[TaxBase.BaseMinusStake] = function (base, cleanStake) { return subtract(base, cleanStake); },
    _a);
function getTaxableAmount(base, cleanStake, taxBase) {
    return taxBaseMethodMapper[taxBase](base, cleanStake);
}
function totalTaxToBrackets(totalTax, brackets, mode, decimalPoint) {
    validateTaxBrackets(brackets);
    var distributionFunc = mode === TaxMode.Progressive
        ? distributeProgressiveTaxToBrackets
        : distributeFlatTaxToBrackets;
    var distributedBrackets = distributionFunc(totalTax, brackets);
    return distributedBrackets.map(function (i) { return (__assign(__assign({}, i), { amount: round(i.amount, decimalPoint) })); });
}
function calculateTaxesPerTicket(_a) {
    var gross = _a.gross, netStake = _a.netStake, taxBase = _a.taxBase, taxBrackets = _a.taxBrackets, taxConfig = _a.taxConfig;
    var taxableBase = getTaxableAmount(gross, netStake, taxBase);
    return calculateTaxes(taxableBase, taxBrackets, taxConfig);
}
function calculateTaxesPerCombinations(systems, taxBrackets, taxConfig) {
    var totalTax = round((taxConfig.maxTax === null || taxConfig.maxTax === undefined)
        ? getTotalTaxForSystemTicket(systems)
        : Math.min(getTotalTaxForSystemTicket(systems), taxConfig.maxTax), taxConfig.totalTaxDecimals);
    return {
        totalTax: totalTax,
        brackets: totalTaxToBrackets(totalTax, taxBrackets, taxConfig.taxMode, taxConfig.bracketTaxDecimals),
    };
}

function calculateStake(total, rate, inverse, rounding) {
    rate = divide(rate, 100);
    var cleanStake = applyTax(total, rate, inverse);
    var roundedCleanStake = rounding !== null ? round(cleanStake, rounding) : cleanStake;
    return {
        amount: roundedCleanStake,
        handlingFee: subtract(total, roundedCleanStake),
    };
}
function calculateStakePerCombination(stake, combinations, rounding) {
    var cleanStakePerCombination = divide(stake, combinations);
    return rounding === undefined ?
        cleanStakePerCombination : round(cleanStakePerCombination, rounding);
}

function multiplyOdds(odds) {
    return odds.reduce(function (a, i) { return multiply(a, i); }, 1);
}

var zeroBonus = {
    current: 0,
    next: 0,
    selectionsNeededForNext: 0,
    maximumPercentage: 0,
};

var SelectionType;
(function (SelectionType) {
    SelectionType["live"] = "live";
    SelectionType["prematch"] = "prematch";
})(SelectionType || (SelectionType = {}));
var SuperOffer;
(function (SuperOffer) {
    SuperOffer["superKvota"] = "superKvota";
    SuperOffer["superExtra"] = "superExtra";
    SuperOffer["superSix"] = "superSix";
    SuperOffer["priceBoost"] = "price_boost";
    SuperOffer["betBoost"] = "bet_boost";
})(SuperOffer || (SuperOffer = {}));
var TicketType;
(function (TicketType) {
    TicketType["online"] = "online";
    TicketType["retail"] = "retail";
})(TicketType || (TicketType = {}));
var NotEligibleReason;
(function (NotEligibleReason) {
    NotEligibleReason["InvalidSelectionTypes"] = "InvalidSelectionTypes";
    NotEligibleReason["TooFewSelections"] = "TooFewSelections";
    NotEligibleReason["TooSmallCoefficient"] = "TooSmallCoefficient";
    NotEligibleReason["RealMoneyLessThanStake"] = "RealMoneyLessThanStake";
    NotEligibleReason["InvalidTicketType"] = "InvalidTicketType";
    NotEligibleReason["SpecialsSelectionUsed"] = "SpecialsSelectionUsed";
    NotEligibleReason["InvalidBetType"] = "InvalidBetType";
})(NotEligibleReason || (NotEligibleReason = {}));
var SuperBonusCalculationBase;
(function (SuperBonusCalculationBase) {
    SuperBonusCalculationBase["Winning"] = "Winning";
    SuperBonusCalculationBase["Profit"] = "Profit";
})(SuperBonusCalculationBase || (SuperBonusCalculationBase = {}));
var SuperBonusValidBetTypes;
(function (SuperBonusValidBetTypes) {
    SuperBonusValidBetTypes["Simple"] = "Simple";
    SuperBonusValidBetTypes["System"] = "System";
})(SuperBonusValidBetTypes || (SuperBonusValidBetTypes = {}));

var OfferType;
(function (OfferType) {
    OfferType["Base"] = "Base";
    OfferType["Special"] = "Special";
    OfferType["SuperOffer"] = "SuperOffer";
})(OfferType || (OfferType = {}));

/**
 * Returns bonusPercentage based on bonus breakpoints and number of selections
 *
 * @param breakpoints Holds info bonus percentage based on numberOfSelections, should be sorted
 * @param numberOfSelections Number of selections on betslip
 * @returns BonusPercentage - currentBonusPercentage, nextBonusPercentage and selectionsNeededForNext
 *
 * @example Simple example
 * ```
 * const breakpoints = [
 *      { numberOfSelections: 4, percentage: 0.2 },
 *      { numberOfSelections: 6, percentage: 0.3 }
 *  ];
 * const bonusPercentage = getBonusPercentage(breakpoints, 4);
 * // {current: 0.2, next: 0.3, selectionsNeededForNext: 2, maximumPercentage: 0.3}
 * console.log(bonusPercentage);
 * ```
 */
function getBonusPercentage(breakpoints, numberOfSelections) {
    if (!breakpoints.length) {
        return zeroBonus;
    }
    var breakpointsLength = breakpoints.length;
    var maximumPercentage = breakpoints[breakpointsLength - 1].percentage;
    var nextIndex, currentIndex;
    nextIndex = breakpoints.findIndex(function (breakpoint) { return (breakpoint.numberOfSelections > numberOfSelections); });
    currentIndex = nextIndex - 1;
    if (nextIndex === -1) {
        // when numberOfSelections is bigger than last breakpoint
        nextIndex = breakpointsLength - 1;
        currentIndex = breakpointsLength - 1;
    }
    var currentBreakpoint = currentIndex === -1 ? null : breakpoints[currentIndex];
    var nextBreakpoint = breakpoints[nextIndex];
    return {
        current: (currentBreakpoint === null || currentBreakpoint === void 0 ? void 0 : currentBreakpoint.percentage) || 0,
        next: nextBreakpoint.percentage,
        selectionsNeededForNext: Math.max(nextBreakpoint.numberOfSelections - numberOfSelections, 0),
        maximumPercentage: maximumPercentage,
    };
}
function parseSuperBonusBreakpoints(superBonusBreakpoints) {
    return superBonusBreakpoints.split('|').map(function (breakpoint) {
        if (!breakpoint.includes('_')) {
            throw new Error('invalid superBonus breakpoint format');
        }
        var _a = __read(breakpoint.split('_').map(Number), 2), numberOfSelections = _a[0], decimal = _a[1];
        if (Number.isNaN(numberOfSelections) || Number.isNaN(decimal) || !Number.isInteger(numberOfSelections)) {
            throw new Error('invalid breakpoint values');
        }
        return {
            numberOfSelections: numberOfSelections,
            percentage: Math.round(decimal * 100),
        };
    });
}
function isTicketTypeValid(type, validTicketTypes) {
    return validTicketTypes.includes(type);
}
// https://www.notion.so/superbet/SuperBonus-2-0-Tech-Specs-118032f852c58031b7aed1be99698e38?pvs=4#121032f852c58046837eeaf28e84f4b5
function isPriceBoostValid(selections, config) {
    if (config.isPriceBoostSbCalculationEnabled) {
        var isPriceBoostIgnoredInConfig = config.ignoredOfferTypes.includes(SuperOffer.priceBoost || SuperOffer.betBoost);
        if (!isPriceBoostIgnoredInConfig) {
            var hasPriceBoostInSelections = selections.some(function (selection) { var _a; return (_a = selection.tags) === null || _a === void 0 ? void 0 : _a.includes(SuperOffer.priceBoost || SuperOffer.betBoost); });
            if (hasPriceBoostInSelections) {
                return false;
            }
        }
    }
    return true;
}
function isOddCoefficientEligible(selection, minCoefficient) {
    return selection.odd >= minCoefficient;
}
function allOddsCoefficientsEligible(selections, minCoefficient) {
    return !selections.some(function (selection) { return selection.odd < minCoefficient; });
}
function isSelectionTypeInvalid(selection, validTypes) {
    var _a;
    return ((_a = selection.marketType) === null || _a === void 0 ? void 0 : _a.kind) === OfferType.Base &&
        !validTypes.includes(selection.marketType.selectionType);
}
function allSelectionTypesValid(selections, validTypes) {
    return !selections.some(function (selection) { return isSelectionTypeInvalid(selection, validTypes); });
}
function isSpecialsSelection(selection) {
    var _a;
    return ((_a = selection.marketType) === null || _a === void 0 ? void 0 : _a.kind) === OfferType.Special;
}
function allSelectionsValidSpecialsCheck(selections, specialsAllowed) {
    if (specialsAllowed) {
        return true;
    }
    return !selections.some(function (selection) { return isSpecialsSelection(selection); });
}
function eligibleOddsCount(selections, minOdd) {
    return selections.filter(function (selection) { return selection.bonusable && selection.odd >= minOdd; }).length;
}
function partitionBonusableSelections(selections) {
    return [
        selections.filter(function (s) { return s.bonusable && !s.tolerable; }),
        selections.filter(function (s) { return !s.bonusable || s.tolerable; }),
    ];
}
function getNumberOfInvalidSelections(selections, purchaseType, _a) {
    var validSelectionTypes = _a.validSelectionTypes, minOddValue = _a.minOddValue, specialsAllowed = _a.specialsAllowed, areSelectionsBelowMinOddTolerated = _a.areSelectionsBelowMinOddTolerated;
    return selections.filter(function (selection) {
        return isSelectionTypeInvalid(selection, validSelectionTypes)
            || (selection.odd < minOddValue && !areSelectionsBelowMinOddTolerated)
            || !specialsAllowed && purchaseType === TicketType.online && isSpecialsSelection(selection);
    }).length;
}
function getReasonForInvalidSelections(selections, purchaseType, _a) {
    var e_1, _b;
    var validSelectionTypes = _a.validSelectionTypes, minOddValue = _a.minOddValue, specialsAllowed = _a.specialsAllowed, areSelectionsBelowMinOddTolerated = _a.areSelectionsBelowMinOddTolerated;
    try {
        for (var selections_1 = __values(selections), selections_1_1 = selections_1.next(); !selections_1_1.done; selections_1_1 = selections_1.next()) {
            var selection = selections_1_1.value;
            if (isSelectionTypeInvalid(selection, validSelectionTypes)) {
                return NotEligibleReason.InvalidSelectionTypes;
            }
            else if (!isOddCoefficientEligible(selection, minOddValue) && !areSelectionsBelowMinOddTolerated) {
                return NotEligibleReason.TooSmallCoefficient;
            }
            else if (!specialsAllowed && purchaseType === TicketType.online && isSpecialsSelection(selection)) {
                return NotEligibleReason.SpecialsSelectionUsed;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (selections_1_1 && !selections_1_1.done && (_b = selections_1.return)) _b.call(selections_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
function getSuperBonusEligibilityByReason(notEligibleReason, invalidEligibleSelections, invalidToleratedSelections, numberOfSelections) {
    return {
        isUnlocked: false,
        isEligible: false,
        numberOfSelections: {
            invalid: invalidEligibleSelections + invalidToleratedSelections,
            eligible: numberOfSelections.eligible - invalidEligibleSelections,
            tolerated: numberOfSelections.tolerated - invalidToleratedSelections,
        },
        notEligibleReason: notEligibleReason,
    };
}
function isUserBalanceInvalid(stake, ticketType, monetaryInfo, stakeRealMoneyOnly) {
    return stakeRealMoneyOnly &&
        ticketType === TicketType.online
        && stake > monetaryInfo.userBalance
        && stake <= monetaryInfo.userBalance + monetaryInfo.sportBonusBalance;
}
// for retail tickets, all selections have to be bonusable for every combination to also be bonusable
function areAllSelectionsBonusable(bonusConfig, selections) {
    if (!bonusConfig || !bonusConfig.isRetail || bonusConfig.areSelectionsBelowMinOddTolerated) {
        return true;
    }
    return allOddsCoefficientsEligible(selections, bonusConfig.minOddValue);
}

// this is only template while Interface for superBonusConfig and function
// for getting oddsCount aren't implemented
function calculateBonus(selections, config, betType) {
    var breakpoints = config.bonusBreakpoints;
    if (!breakpoints.length) {
        return zeroBonus;
    }
    var zeroBonusWithMaxPercentage = __assign(__assign({}, zeroBonus), { maximumPercentage: breakpoints[breakpoints.length - 1].percentage });
    if (!config.superBonusEnabled) {
        return zeroBonus;
    }
    // if betType is not provided, skip isBetTypeValid check, this is for backwards compatibility
    if (betType) {
        var isSystemTicket = betType === SuperBonusValidBetTypes.System;
        if (!isBetTypeValidForSuperBonus(config, isSystemTicket)) {
            return zeroBonus;
        }
    }
    // when implementing SuperBonus 2.0 we had some issues with SuperBonus for normal multi tickets,
    // so in coordination with betting team we decided to remove SuperBonus for them
    if (selections.some(function (selection) { return selection.multiNo; })) {
        return zeroBonus;
    }
    if (!config.areSelectionsBelowMinOddTolerated && !allOddsCoefficientsEligible(selections, config.minOddValue)) {
        return zeroBonusWithMaxPercentage;
    }
    if (!allSelectionTypesValid(selections, config.validSelectionTypes)) {
        return zeroBonusWithMaxPercentage;
    }
    if (!allSelectionsValidSpecialsCheck(selections, config.specialsAllowed)) {
        return zeroBonusWithMaxPercentage;
    }
    var oddsCount = eligibleOddsCount(selections, config.minOddValue);
    return getBonusPercentage(breakpoints, oddsCount);
}
function calculateBonusPercentage$1(selections, config) {
    return calculateBonus(selections, config).current;
}
function isSuperBonusEligible(stake, ticketType, monetaryInfo, selections, config, betType) {
    var _a = __read(partitionBonusableSelections(selections), 2), eligibleSelections = _a[0], toleratedSelections = _a[1];
    var numberOfSelections = {
        eligible: eligibleSelections.length,
        tolerated: toleratedSelections.length,
        invalid: 0,
    };
    // if PriceBoost decoupling FeatureFlag is on, PriceBoost odds cancel SuperBonus
    if (!isPriceBoostValid(selections, config)) {
        return {
            isUnlocked: false,
            isEligible: false,
            numberOfSelections: numberOfSelections,
            notEligibleReason: NotEligibleReason.InvalidSelectionTypes,
        };
    }
    if (!isTicketTypeValid(ticketType, config.validTicketTypes)) {
        return {
            isUnlocked: false,
            isEligible: false,
            numberOfSelections: numberOfSelections,
            notEligibleReason: NotEligibleReason.InvalidTicketType,
        };
    }
    // if betType is not provided, skip isBetTypeValid check, this is for backwards compatibility
    if (betType) {
        var isSystemTicket = betType === SuperBonusValidBetTypes.System;
        if (!isBetTypeValidForSuperBonus(config, isSystemTicket)) {
            return {
                isUnlocked: false,
                isEligible: false,
                numberOfSelections: numberOfSelections,
                notEligibleReason: NotEligibleReason.InvalidBetType,
            };
        }
    }
    var invalidEligibleSelections = getNumberOfInvalidSelections(eligibleSelections, ticketType, config);
    var invalidToleratedSelections = getNumberOfInvalidSelections(toleratedSelections, ticketType, config);
    var reason = getReasonForInvalidSelections(selections, ticketType, config);
    if (reason) {
        return getSuperBonusEligibilityByReason(reason, invalidEligibleSelections, invalidToleratedSelections, numberOfSelections);
    }
    if (isUserBalanceInvalid(stake, ticketType, monetaryInfo, config.stakeRealMoneyOnly || false)) {
        return {
            isUnlocked: false,
            isEligible: false,
            numberOfSelections: numberOfSelections,
            notEligibleReason: NotEligibleReason.RealMoneyLessThanStake,
        };
    }
    if (eligibleSelections.length < config.bonusBreakpoints[0].numberOfSelections) {
        return {
            isUnlocked: false,
            isEligible: true,
            numberOfSelections: numberOfSelections,
            notEligibleReason: NotEligibleReason.TooFewSelections,
        };
    }
    return {
        isUnlocked: true,
        isEligible: true,
        numberOfSelections: numberOfSelections,
        notEligibleReason: null,
    };
}

function calculateBonusPercentage(selections, config) {
    if (!config) {
        return 0;
    }
    return calculateBonusPercentage$1(selections, config);
}

var BonusSelection = /** @class */ (function () {
    function BonusSelection(selection, bonusConfig) {
        var _a, _b;
        var bonusable = ((_a = selection.marketType) === null || _a === void 0 ? void 0 : _a.kind) === OfferType.SuperOffer ?
            !bonusConfig.ignoredOfferTypes.includes((_b = selection.marketType) === null || _b === void 0 ? void 0 : _b.offerType)
            : true;
        this.odd = selection.odd;
        this.marketType = selection.marketType;
        this.multiNo = selection.multiNo;
        this.groupNo = selection.groupNo;
        this.bonusable = bonusable;
        this.tolerable = bonusable &&
            !!bonusConfig.areSelectionsBelowMinOddTolerated &&
            selection.odd < bonusConfig.minOddValue;
    }
    return BonusSelection;
}());

function mapPayoutToBonusSelections(selections, bonusConfig) {
    return selections.map(function (s) { return new BonusSelection(s, bonusConfig); });
}

var BinarySystem;
(function (BinarySystem) {
    BinarySystem["One"] = "1";
    BinarySystem["Zero"] = "0";
})(BinarySystem || (BinarySystem = {}));

/**
 * Generates all unique k-combinations from set S
 * Using Combinatorial number system as fast method to get all combinations
 * https://en.wikipedia.org/wiki/Combinatorial_number_system
 * @param elements - set of all elements we can make combinations from
 * @param k - how many elements we choose for one combination
 *
 * @returns all k-combinations of set S
 *
 * @example Simple example
 * ```
 * const combinations = getCombinations([0, 1, 2, 3], 2);
 * // [[0, 1], [0, 2], [1, 2], [0, 3], [1, 3], [2, 3]]
 * console.log(combinations);
 * ```
 */
function getCombinations(elements, k) {
    var combinations = [];
    if (!areElementsUnique(elements)) {
        throw new Error('getCombinations elements are not unique');
    }
    if (elements.length < k || k < 0) {
        throw new Error("getCombinations invalid k, k = " + k);
    }
    if (k === 0) {
        return [];
    }
    var combination = getFirstEncoding(elements.length, k);
    while (combination) {
        combinations.push(getCombinationFromEncoding(elements, combination));
        combination = getNextEncoding(combination);
    }
    return combinations;
}
// this is used instead of more readable const uniqueS = [...new Set(S)]
// because Set polyfill increases bundle size a lot
function areElementsUnique(elements) {
    var seen = {};
    var uniqueElements = elements.filter(function (element) {
        if (seen[element]) {
            return false;
        }
        seen[element] = true;
        return true;
    });
    return uniqueElements.length === elements.length;
}
/**
 * Encodes starting combination with string in binary format
 * @param n - length of set we choose combinations from
 * @param k - how many element we choose for single combination
 *
 * @returns combination encoded with string
 *
 * @example First encoding for n = 5, k = 2
 * ```
 * const firstEncoding = getFirstEncoding(5, 2);
 * // 00011
 * console.log(firstEncoding);
 * // If we have set [1, 2, 3, 4, 5] 00011 encodes combination [1, 2]
 * ```
 */
function getFirstEncoding(n, k) {
    return BinarySystem.Zero
        .repeat(n - k)
        .concat(BinarySystem.One.repeat(k));
}
/**
 * Get combination from set S encoded with encoding
 * @param elements - set of elements
 * @param encoding - representation of combination in 'binary' format
 * @returns combination represented with encoding
 *
 * @example getCombinationsFromEncoding([0, 1, 2], '110)
 * ```
 * // [0, 1]
 * console.log(getCombinationsFromEncoding([0, 1, 2], '110);
 * ```
 */
function getCombinationFromEncoding(elements, encoding) {
    return elements.filter(function (element, i) {
        return encoding[elements.length - i - 1] === BinarySystem.One;
    });
}
/**
 * Get next encoded combination.
 * @param encoding encoded combination
 * @returns next encoded combination or null if got to last combination
 *
 * @example get combination after '0011'
 * ```
 * // '0101'
 * console.log(getNextEncoding('0011'));
 * ```
 */
function getNextEncoding(encoding) {
    if (isLastEncoding(encoding)) {
        return null;
    }
    var nextEncoding = getNextNumberWithSameNumberOfSetBits(parseInt(encoding, 2));
    return nextEncoding
        .toString(2)
        .padStart(encoding.length, BinarySystem.Zero);
}
/**
 * check if encoding is last combination
 * @param encoding encoded combination
 * @returns true if last combination, otherwise false
 *
 * @example last combination
 * // true
 * console.log(isLastEncoding('11100');
 *
 * @example not last combination
 * // false
 * console.log(isLastEncoding('11010');
 */
function isLastEncoding(encoding) {
    var numberOfOnes = encoding.split(BinarySystem.One).length - 1;
    return encoding.startsWith(BinarySystem.One.repeat(numberOfOnes));
}
/**
 * Returns next combination encoded with number - same number of set bits.
 * Representing encoding with number because bitwise operations are much faster
 * than string manipulations.
 * Code example and explanation https://www.geeksforgeeks.org/next-higher-number-with-same-number-of-set-bits
 * @param current combination represented by number
 */
function getNextNumberWithSameNumberOfSetBits(current) {
    var rightOne = current & -current;
    var nextHigherOneBit = current + rightOne;
    var rightOnesPattern = current ^ nextHigherOneBit;
    rightOnesPattern = rightOnesPattern / rightOne;
    rightOnesPattern >>= 2;
    return nextHigherOneBit | rightOnesPattern;
}

var Group = /** @class */ (function () {
    function Group() {
        this.selectionCount = 0;
        this.multiNumbersToSelectionCounts = {};
    }
    Group.prototype.addSelection = function (multiNo) {
        this.selectionCount++;
        if (multiNo) {
            if (!this.multiNumbersToSelectionCounts[multiNo]) {
                this.multiNumbersToSelectionCounts[multiNo] = 0;
            }
            this.multiNumbersToSelectionCounts[multiNo]++;
        }
    };
    Group.prototype.combinationCount = function () {
        return Object.values(this.multiNumbersToSelectionCounts).reduce(function (combinationCount, multiSelectionCount) { return combinationCount * multiSelectionCount; }, 1);
    };
    return Group;
}());

function systemNumberOfCombinations(selectionsCount, system) {
    return divide(factorial(selectionsCount), multiply(factorial(system), factorial(subtract(selectionsCount, system))));
}
function systemsNumberOfCombinations(selectionsCount, systems) {
    return systems.reduce(function (a, system) { return a + systemNumberOfCombinations(selectionsCount, system); }, 0);
}
function generateSystemCombinations(selections, system) {
    var selectionsCount = selections.length;
    if (system > selectionsCount) {
        return [];
    }
    return getCombinations(selections, system);
}
function cartesian(array) {
    if (!array || array.length === 0) {
        return [];
    }
    return _cartesian(array);
}
function _cartesian(array) {
    if (array.length === 1) {
        return array[0].map(function (i) { return ([i]); });
    }
    var _a = __read(array), group = _a[0], rest = _a.slice(1);
    return group.reduce(function (acc, num) {
        var combs = _cartesian(rest);
        acc.push.apply(acc, __spreadArray([], __read(combs.map(function (comb) { return __spreadArray([num], __read(comb)); }))));
        return acc;
    }, []);
}
/*
* Returns number of combinations for selections with single system
*/
function getNumberOfCombinationsForSystem(selections, system) {
    if (selections.length < 1 || !system) {
        return 0;
    }
    var groupNumbersToGroups = preprocessGroups(selections);
    var groupNumbersToCombinationCounts = Object.entries(groupNumbersToGroups).reduce(function (acc, _a) {
        var _b = __read(_a, 2), groupNo = _b[0], group = _b[1];
        acc[+groupNo] = group.combinationCount();
        return acc;
    }, {});
    var fixCombinationCount = groupNumbersToCombinationCounts[0] || 1;
    var systemCombinationCount = calculateSystemCombinationCount(groupNumbersToCombinationCounts, system);
    return fixCombinationCount * systemCombinationCount;
}
function calculateSystemCombinationCount(groupNumbersToCombinationCounts, system) {
    var groupCombinationCounts = Object.entries(groupNumbersToCombinationCounts).reduce(function (acc, _a) {
        var _b = __read(_a, 2), groupNo = _b[0], groupCombinationCount = _b[1];
        if (+groupNo > 0) {
            acc.push(groupCombinationCount);
        }
        return acc;
    }, []);
    if (groupCombinationCounts.length === 0) {
        return 1;
    }
    // this part of the code is optimised using Frans system calculation algorithm
    // https://www.notion.so/axilis/Settlement-Service-2518687f8bb2490bbd6ab5baed5bd6aa
    var groupOptionsToCombinationCounts = {};
    var lastIterationSums = new Array(groupCombinationCounts.length).fill(0);
    var lastIterationRes = 1;
    for (var i = 1; i < groupCombinationCounts.length + 1; i++) {
        for (var j = 0; j < lastIterationSums.length; j++) {
            lastIterationSums[j] = groupCombinationCounts[j] * (lastIterationRes - lastIterationSums[j]);
        }
        lastIterationRes = lastIterationSums.reduce(function (sum, i) { return sum + i; }, 0);
        lastIterationRes = lastIterationRes / i;
        groupOptionsToCombinationCounts[i] = lastIterationRes;
    }
    return groupOptionsToCombinationCounts[system];
}
function preprocessGroups(selections) {
    return selections.reduce(function (groupNumbersToGroups, selection) {
        var groupNo = selection.groupNo || 0;
        var group = groupNumbersToGroups[groupNo];
        if (!group) {
            group = new Group();
            groupNumbersToGroups[groupNo] = group;
        }
        group.addSelection(selection.multiNo || 0);
        return groupNumbersToGroups;
    }, {});
}

function limitWin(amount, max) {
    return Math.min(amount, max);
}
function calculateRecommendedStake(grossStake, gross, maxWin) {
    if (gross <= maxWin) {
        return grossStake;
    }
    var winOverflow = subtract(gross, maxWin);
    var winOverflowPercentage = divide(winOverflow, gross);
    var recommendedStake = subtract(grossStake, multiply(grossStake, winOverflowPercentage));
    // HACK which makes sure that the recommended stake will always return equal or greater than max win
    // This is needed because of rounding
    // Discussion: https://github.com/superbet-group/betting.lib.payments/pull/52
    var adjustedRecommendedStake = divide(Math.ceil(multiply(recommendedStake, 100)), 100);
    return round(adjustedRecommendedStake, 2);
}
function getNet(gross, totalTax, amountsRounding) {
    return round(subtract(gross, totalTax), amountsRounding);
}
function isSystemTicket(selectionsCount, systems) {
    if (systems.length === 0) {
        return false;
    }
    if (systems.length === 1 && systems[0] === selectionsCount) {
        return false;
    }
    return true;
}
function isNormalTicket(selections, systems) {
    if (selections.some(function (selection) { return selection.multiNo; })) {
        return false;
    }
    if (!systems || systems.length === 0) {
        return true;
    }
    // get number of unique groups without fixed selections (groupNo = 0)
    var uniqueGroupCount = new Set(selections.filter(function (selection) { return selection.groupNo; }).map(function (selection) { return selection.groupNo; })).size;
    // system that is X/X(eg 8/8) is calculated as a normal ticket
    var isConsideredNormal = systems && systems.length === 1 && systems[0] === uniqueGroupCount;
    return isConsideredNormal || selections.every(function (selection) { return !selection.groupNo; });
}

var MultiGenerator = /** @class */ (function () {
    function MultiGenerator(selections, indices) {
        var e_1, _a;
        var multiNumberToInternalIdx = {};
        var multiSelectionsGroups = [];
        var nonMultiSelections = [];
        try {
            // Selections which have the same multi group number should be grouped together.
            // In a combination exactly one Selection needs to be taken out of each group.
            // e.g. Multi group 1 has Selections A and B; and multi group 2 has Selections D and E.
            //      Possible combinations here are: AD, AE, BD and BE.
            //      Combination AB cannot appear since A and B are in the same multi group.
            for (var indices_1 = __values(indices), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
                var multiIdx = indices_1_1.value;
                var selection = selections[multiIdx];
                if (selection.multiNo) {
                    var groupNumber = selection.multiNo;
                    var groupIdx = groupNumber ? multiNumberToInternalIdx[groupNumber] : undefined;
                    if (groupIdx === undefined || groupIdx === null) {
                        multiNumberToInternalIdx[groupNumber] = multiSelectionsGroups.length;
                        multiSelectionsGroups.push([multiIdx]);
                    }
                    else {
                        multiSelectionsGroups[groupIdx].push(multiIdx);
                    }
                }
                else {
                    nonMultiSelections.push(multiIdx);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (indices_1_1 && !indices_1_1.done && (_a = indices_1.return)) _a.call(indices_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.multiSelectionsGroups = multiSelectionsGroups;
        this.nonMultiSelections = nonMultiSelections;
    }
    MultiGenerator.prototype.generate = function () {
        var _this = this;
        var combinations = cartesian(this.multiSelectionsGroups);
        if (!combinations.length) {
            return [__spreadArray([], __read(this.nonMultiSelections))];
        }
        return combinations.map(function (comb) { return __spreadArray(__spreadArray([], __read(comb)), __read(_this.nonMultiSelections)); });
    };
    return MultiGenerator;
}());

var SystemGenerator = /** @class */ (function () {
    function SystemGenerator(selections, multiSelectionsProxy) {
        var groupNumberToInternalIdx = {};
        var fixSelections = [];
        var systemSelectionsGroups = [];
        // Selections can either be fixed or part of a system group.
        // A fixed selection needs to appear in every generated combination.
        // Every non-fixed selection is a part of a system group.
        // Every system group can be chosen for a particular combination - when a system group
        // is "chosen" in a combination it means that all of the selections in that
        // group should be in that combination.
        // For example, given selections A, B, C, D and E which are grouped in system groups as
        // (A, B), (C) and (D); and with E being a fixed selection.
        // Possible combinations for a 2/3 system here are: ABCE, ABDE and CDE.
        // Notice how E always appears since it's a fixed selection and how A and B always appear
        // together as they are a part of the same group
        for (var multiGroupIdx = 0; multiGroupIdx < multiSelectionsProxy.length; multiGroupIdx++) {
            var idx = multiSelectionsProxy[multiGroupIdx][0];
            var selection = selections[idx];
            if (!selection.groupNo) {
                fixSelections.push(multiGroupIdx);
            }
            else {
                var groupNumber = selection.groupNo;
                var groupIdx = groupNumberToInternalIdx[groupNumber];
                if (groupIdx === undefined) {
                    // If we didn't add it as a new key to the map and add current selection
                    // as the first value to that entry
                    groupNumberToInternalIdx[groupNumber] = systemSelectionsGroups.length;
                    systemSelectionsGroups.push([multiGroupIdx]);
                }
                else {
                    // If we did just add current selection to that entry in the map
                    systemSelectionsGroups[groupIdx].push(multiGroupIdx);
                }
            }
        }
        this.fixSelections = fixSelections;
        this.systemSelectionsGroups = systemSelectionsGroups;
    }
    SystemGenerator.prototype.generate = function (system) {
        var _this = this;
        // `Combination` returns indices of which groups of selections are in the current combination.
        // It returns the results in-place in the given `g.currentCombinationGroupIndices` slice.
        var combs = getCombinations(this.systemSelectionsGroups.map(function (_, i) { return i; }), system);
        // Best guess on how much memory to preallocate for this slice. Assumption here
        // is that every system group that's going to be chosen has exactly one selection in it.
        // In case there are more selections in one of the chosen system groups reallocation(s)
        // will occur but this shouldn't be a major performance hit
        return combs.map(function (comb) {
            var e_1, _a;
            var combination = [];
            try {
                for (var comb_1 = __values(comb), comb_1_1 = comb_1.next(); !comb_1_1.done; comb_1_1 = comb_1.next()) {
                    var groupIdx = comb_1_1.value;
                    combination.push.apply(combination, __spreadArray([], __read(_this.systemSelectionsGroups[groupIdx])));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (comb_1_1 && !comb_1_1.done && (_a = comb_1.return)) _a.call(comb_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            combination.push.apply(combination, __spreadArray([], __read(_this.fixSelections)));
            return combination;
        });
    };
    return SystemGenerator;
}());

function calculateCombinations(selectionCount, systems, systemsCombinations) {
    if (systems.length === 1 && systems[0] === selectionCount) {
        return 1;
    }
    return systemsCombinations.length;
}
/**
 * @deprecated since version v3.12.1
 */
function generateSystemsCombinations(selections, systems) {
    var indices = arrayIndices(selections);
    return systems.flatMap(function (system) { return generateSystemCombinations(indices, system); });
}
/*
* Returns list of combinations where each combination is represented with selections's indices
*/
function generateCombinations(selections, systems) {
    var e_1, _a;
    if (isNormalTicket(selections, systems)) {
        return [selections.map(function (_, i) { return i; })];
    }
    if (systems.length === 0) {
        // Initialise the multi generator and iterate over multi combinations
        var multiGenerator = new MultiGenerator(selections, selections.map(function (_, idx) { return idx; }));
        return multiGenerator.generate();
    }
    var multiSelectionsProxy = createMultiSelectionsProxy(selections);
    var systemGenerator = new SystemGenerator(selections, multiSelectionsProxy);
    var combinations = [];
    try {
        // Start iterating over system options (e.g. 1/5, 2/5...)
        for (var systems_1 = __values(systems), systems_1_1 = systems_1.next(); !systems_1_1.done; systems_1_1 = systems_1.next()) {
            var system = systems_1_1.value;
            var systemSelections = systemGenerator.generate(system);
            // systemSelections have multi indices from multiSelectionsProxy
            systemSelections.forEach(function (systemSelection) {
                // Selection indices "picked" by the system generator, these are not yet
                // dereferenced to the actual underlying selections on the ticket.
                // Get the indices of the actual ticket selections in this system combination
                var dereferencedSelectionsIndices = dereferenceMultiIndices(multiSelectionsProxy, systemSelection);
                // Initialise the multi generator and store all multi combinations
                var multiGenerator = new MultiGenerator(selections, dereferencedSelectionsIndices);
                var multiCombinations = multiGenerator.generate();
                combinations.push.apply(combinations, __spreadArray([], __read(multiCombinations)));
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (systems_1_1 && !systems_1_1.done && (_a = systems_1.return)) _a.call(systems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return combinations;
}
function createMultiSelectionsProxy(underlyingSelections) {
    var proxySelectionGroups = [];
    var multiGroupNumberToSelectionGroupIndex = {};
    for (var idx = 0; idx < underlyingSelections.length; idx++) {
        var selection = underlyingSelections[idx];
        if (!selection.multiNo) {
            // If it's not a multi selection just add it to the groups list as a solo selection
            proxySelectionGroups.push([idx]);
        }
        else {
            // If it is a multi selection check if its multi-group has already been encountered
            var selectionGroupIdx = multiGroupNumberToSelectionGroupIndex[selection.multiNo];
            if (!selectionGroupIdx) {
                // If this is the first time we encountered this multi group add it to the proxy
                // selection groups and save the index of that group to the temporary map.
                multiGroupNumberToSelectionGroupIndex[selection.multiNo] = proxySelectionGroups.length;
                proxySelectionGroups.push([idx]);
            }
            else {
                // If this is not the first time we encountered this multi group just add it to the
                // list of the previously encountered selections from that same multi group.
                proxySelectionGroups[selectionGroupIdx].push(idx);
            }
        }
    }
    return proxySelectionGroups;
}
function dereferenceMultiIndices(multiSelectionsProxy, indices) {
    return indices.flatMap(function (groupIndex) { return multiSelectionsProxy[groupIndex]; });
}

function calculateSystems(data) {
    var netStake = data.netStake, bonusConfig = data.bonusConfig, taxBrackets = data.taxBrackets, taxConfig = data.taxConfig, roundingPerCombination = data.roundingPerCombination, roundToRealMoneyAmounts = data.roundToRealMoneyAmounts, useNewCombinationGenerator = data.useNewCombinationGenerator;
    var _a = getSystemsAndSelections(data.systems, data.selections, useNewCombinationGenerator), systems = _a.systems, selections = _a.selections;
    var _b = getCombinationsAndCombinationsMapper(systems, selections, useNewCombinationGenerator), combinations = _b.combinations, combinationToSelectionMapper = _b.combinationToSelectionMapper;
    var numberOfCombinations = calculateCombinations(selections.length, systems, combinations);
    var stakePerCombination = calculateStakePerCombination(netStake, numberOfCombinations, roundingPerCombination);
    // retail has a specific rule that all selections on ticket must be bonusable
    var allSelectionsBonusable = areAllSelectionsBonusable(bonusConfig, mapPayoutToBonusSelections(selections, bonusConfig));
    var calculateBonus = allSelectionsBonusable && isBetTypeValidForSuperBonus(bonusConfig, isSystemTicket(selections.length, systems));
    var payouts = calculateSystemsCombinationsPayouts(combinations, combinationToSelectionMapper, stakePerCombination, bonusConfig, taxBrackets, taxConfig, calculateBonus, roundToRealMoneyAmounts);
    return {
        numberOfCombinations: numberOfCombinations,
        stakePerCombination: stakePerCombination,
        payouts: payouts,
    };
}
function isBetTypeValidForSuperBonus(bonusConfig, isTicketSystem) {
    var validBetTypesConfig = bonusConfig === null || bonusConfig === void 0 ? void 0 : bonusConfig.validBetTypes;
    // Current requirement is that if no validBetTypes are provided, the bonus is enabled
    if (!validBetTypesConfig) {
        return true;
    }
    var currentBetType = isTicketSystem
        ? SuperBonusValidBetTypes.System
        : SuperBonusValidBetTypes.Simple;
    return validBetTypesConfig.includes(currentBetType);
}
function calculateSystemsCombinationsPayouts(systemsCombinations, combinationToSelectionMapper, stake, config, taxBrackets, taxConfig, calculateBonus, roundToRealMoneyAmounts) {
    return systemsCombinations.map(function (comb) {
        return calculateCombinationPayout(combinationToSelectionMapper(comb), stake, config, taxBrackets, taxConfig, calculateBonus, roundToRealMoneyAmounts);
    });
}
function calculateCombinationPayout(selections, stake, bonusConfig, taxBrackets, taxConfig, calculateBonus, roundToRealMoneyAmounts) {
    var odd = multiplyOdds(selections.map(function (i) { return i.odd; }));
    var base = multiply(odd, stake);
    var bonusPercentage = calculateBonus ? calculateBonusPercentage(mapPayoutToBonusSelections(selections, bonusConfig), bonusConfig) : 0;
    var bonusBase = getBonusBase(base, stake, bonusConfig === null || bonusConfig === void 0 ? void 0 : bonusConfig.calculationBase);
    var bonus = getBonus(bonusBase, bonusPercentage, roundToRealMoneyAmounts);
    var tax = calculateTaxes(add(base, bonus), taxBrackets, taxConfig);
    return {
        base: base,
        bonus: bonus,
        odd: odd,
        tax: tax,
    };
}
function payoutTotals(systemPayouts) {
    return systemPayouts.reduce(function (a, i) {
        a.base = add(a.base, i.base);
        a.bonus = add(a.bonus, i.bonus);
        a.odd = add(a.odd, i.odd);
        return a;
    }, { base: 0, bonus: 0, odd: 0 });
}
function findMinWinCombination(systems) {
    return systems.reduce(function (min, c) { return (c.base < min.base ? c : min); }, systems[0]);
}
function getTaxes(_a) {
    var systems = _a.systems, gross = _a.gross, netStake = _a.netStake, taxBase = _a.taxBase, taxBrackets = _a.taxBrackets, taxConfig = _a.taxConfig, taxPerSystem = _a.taxPerSystem;
    if (taxPerSystem) {
        return calculateTaxesPerCombinations(systems, taxBrackets, taxConfig);
    }
    else {
        return calculateTaxesPerTicket({
            gross: gross,
            netStake: netStake,
            taxBase: taxBase,
            taxBrackets: taxBrackets,
            taxConfig: taxConfig
        });
    }
}
function getSystemsAndSelections(systems, selections, useNewCombinationGenerator) {
    if (!useNewCombinationGenerator && (!systems || systems.length === 0)) {
        // convert the 'simple' ticket to system x/x ticket
        return {
            systems: [selections.length],
            // in the case when there are no systems, for further calculations the library assumes all selections are not fixed
            selections: selections.map(function (s) { return (__assign(__assign({}, s), { fixed: false })); })
        };
    }
    else {
        return { systems: systems, selections: selections };
    }
}
function getCombinationsAndCombinationsMapper(systems, selections, useNewCombinationGenerator) {
    if (useNewCombinationGenerator) {
        var combinations = generateCombinations(selections, systems);
        var combinationToSelectionMapper = function (combination) { return combination.map(function (idx) { return selections[idx]; }); };
        return {
            combinations: combinations,
            combinationToSelectionMapper: combinationToSelectionMapper
        };
    }
    else {
        var fixedSelections_1 = selections.filter(function (i) { return i.fixed; });
        var nonFixedSelections_1 = selections.filter(function (i) { return !i.fixed; });
        var combinations = generateSystemsCombinations(nonFixedSelections_1, systems);
        var combinationToSelectionMapper = function (combination) { return __spreadArray(__spreadArray([], __read(fixedSelections_1)), __read(combination.map(function (idx) { return nonFixedSelections_1[idx]; }))); };
        return {
            combinations: combinations,
            combinationToSelectionMapper: combinationToSelectionMapper
        };
    }
}
function getBonusBase(base, stake, calculationBase) {
    if (calculationBase === void 0) { calculationBase = SuperBonusCalculationBase.Winning; }
    // https://www.notion.so/superbet/Adjusting-SuperBonus-Calculation-from-Winnings-to-Profit-5b56d78d003b4df697cef9fd2e5fbf27
    switch (calculationBase) {
        case SuperBonusCalculationBase.Winning:
            return base;
        case SuperBonusCalculationBase.Profit:
            return base - stake;
        default:
            return 0; // unreachable
    }
}

function calculateSportPayout(selections, systems, grossStake, config, callback) {
    try {
        var calculatedPayout = _calculateSportPayout(selections, systems, grossStake, config);
        if (!callback) {
            return calculatedPayout;
        }
        callback(null, calculatedPayout);
    }
    catch (e) {
        if (!callback) {
            throw e;
        }
        callback(e);
    }
}
function _calculateSportPayout(selections, systems, grossStake, config) {
    if (grossStake < 0) {
        throw new Error('grossStake must be >= 0');
    }
    if (!systems) {
        throw new Error('systems must be provided to calculateSportPayout');
    }
    // TODO: we need some validations to ensure that the systems and selections work
    var roundStake = shouldRoundStake(selections, systems, config.useNewCombinationGenerator || false);
    var amountsRounding = config.rounding.amounts;
    var stakeCalculationsRounding = roundStake
        ? config.rounding.stakeCalculations.simple
        : config.rounding.stakeCalculations.system;
    var calculatedStake = calculateStake(grossStake, config.handlingFeeRate, config.handlingFeeInverse, stakeCalculationsRounding);
    var taxConfig = {
        taxMode: config.taxMode,
        totalTaxDecimals: config.rounding.preFinal.totalTax,
        bracketTaxDecimals: config.rounding.tax.brackets,
        maxTax: getMaxTax(config.maxWin, config.taxBrackets),
    };
    var taxPerSystem = config.taxPerSystem, taxBrackets = config.taxBrackets, taxBase = config.taxBase;
    // this is the meat of the thing -> it returns payout calculations for each possible combination
    var calculatedSystems = calculateSystems({
        selections: selections,
        systems: systems,
        netStake: calculatedStake.amount,
        bonusConfig: config.bonusConfig,
        taxBrackets: taxBrackets,
        taxConfig: taxConfig,
        roundingPerCombination: config.rounding.stakeCalculations.perCombination,
        roundToRealMoneyAmounts: config.rounding.roundToRealMoneyAmounts,
        useNewCombinationGenerator: config.useNewCombinationGenerator
    });
    // calculate max potential win
    var totals = payoutTotals(calculatedSystems.payouts);
    var unlimitedGrossMax = add(totals.base, totals.bonus);
    var grossMax = round(limitWin(unlimitedGrossMax, config.maxWin), config.rounding.preFinal.amounts);
    var maxTaxes = getTaxes({
        systems: calculatedSystems.payouts,
        gross: grossMax,
        netStake: calculatedStake.amount,
        taxBase: taxBase,
        taxBrackets: taxBrackets,
        taxConfig: taxConfig,
        taxPerSystem: taxPerSystem,
    });
    var maxNet = getNet(grossMax, maxTaxes.totalTax, amountsRounding);
    // if recommendStake flag is true, calculate the recommendedStake
    var maxWinRecommendedStake = {};
    if (config.recommendStake) {
        Object.assign(maxWinRecommendedStake, {
            recommendedStake: calculateRecommendedStake(grossStake, unlimitedGrossMax, config.maxWin),
        });
    }
    // calculate min potential win
    var minCombination = findMinWinCombination(calculatedSystems.payouts);
    var grossMin = round(limitWin(add(minCombination.base, minCombination.bonus), config.maxWin), config.rounding.preFinal.amounts);
    var minTaxes = getTaxes({
        systems: [minCombination],
        gross: grossMin,
        netStake: calculatedStake.amount,
        taxBase: taxBase,
        taxBrackets: taxBrackets,
        taxConfig: taxConfig,
        taxPerSystem: taxPerSystem,
    });
    var minNet = getNet(grossMin, minTaxes.totalTax, amountsRounding);
    var grossMaxRounded = round(grossMax, amountsRounding);
    var grossMinRounded = round(grossMin, amountsRounding);
    var _a = calculateBonuses(selections, systems, config, totals, minCombination, amountsRounding), maxWinBonus = _a.maxWinBonus, minWinBonus = _a.minWinBonus;
    return {
        combinations: calculatedSystems.numberOfCombinations,
        stake: __assign({ amount: round(calculatedStake.amount, amountsRounding), handlingFee: round(calculatedStake.handlingFee, amountsRounding), stakePerCombination: round(calculatedSystems.stakePerCombination, amountsRounding) }, maxWinRecommendedStake),
        maxWin: {
            taxes: roundTotalTaxes(maxTaxes, config.rounding.tax.total),
            net: maxNet,
            base: round(totals.base, amountsRounding),
            bonus: maxWinBonus,
            gross: grossMaxRounded,
        },
        minWin: {
            taxes: roundTotalTaxes(minTaxes, config.rounding.tax.total),
            net: minNet,
            base: round(minCombination.base, amountsRounding),
            bonus: minWinBonus,
            gross: grossMinRounded,
        },
        hasBeenLimited: unlimitedGrossMax > config.maxWin,
        combinationsOddSum: round(totals.odd, 2),
    };
}
function shouldRoundStake(selections, systems, useNewCombinationGenerator) {
    return useNewCombinationGenerator
        ? isNormalTicket(selections, systems)
        : !isSystemTicket(selections.length, systems);
}
function calculateBonuses(selections, systems, config, totals, minCombination, amountsRounding) {
    var isTicketSystem = isSystemTicket(selections.length, systems);
    if (!isBetTypeValidForSuperBonus(config.bonusConfig, isTicketSystem)) {
        return { maxWinBonus: 0, minWinBonus: 0 };
    }
    // when implementing SuperBonus 2.0 we had some issues with SuperBonus for normal multi tickets, 
    // so in coordination with betting team we decided to remove SuperBonus for them
    if (selections.some(function (selection) { return selection.multiNo; })) {
        return { maxWinBonus: 0, minWinBonus: 0 };
    }
    var maxWinBonus = round(Math.min(totals.bonus, config.maxWin), amountsRounding);
    var minWinBonus = round(Math.min(minCombination.bonus, config.maxWin), amountsRounding);
    return { maxWinBonus: maxWinBonus, minWinBonus: minWinBonus };
}

function calculateLottoSystemWinPerBall(betslipData, config) {
    var selectionsCount = betslipData.selectionsCount, systems = betslipData.systems, odds = betslipData.odds, numbersDrawn = betslipData.numbersDrawn, grossStake = betslipData.grossStake;
    var combinations = systemsNumberOfCombinations(selectionsCount, systems);
    var calculatedStake = calculateStake(grossStake, config.handlingFeeRate, config.handlingFeeInverse, config.rounding);
    var stakePerCombination = calculateStakePerCombination(calculatedStake.amount, combinations, config.perCombinationRounding);
    var validSystemCount = Math.min(selectionsCount, numbersDrawn);
    var validSystems = Array.from({ length: validSystemCount }).map(function (_, i) { return i + 1; });
    return validSystems.reduce(function (acc, ball) {
        var _a;
        // we find all the systems which are lower or equal to the number of balls
        var applicableSystems = systems.filter(function (i) { return i <= ball; });
        // for each system and the total number of balls we calculate the total win
        var systemsAcc = applicableSystems.reduce(function (systemsAcc, system) {
            var combinations = systemNumberOfCombinations(ball, system);
            var odd = odds[system - 1];
            return add(multiplyAll([odd, combinations, stakePerCombination]), systemsAcc);
        }, 0);
        return Object.assign(acc, (_a = {}, _a[ball] = round(limitWin(systemsAcc, config.maxWin), 2), _a));
    }, {});
}
function calculateLottoMaxPotentialWin(selectionsCount, systems, odds, stakePerCombination) {
    return systems.reduce(function (maxWin, system) {
        var systemCombinations = systemNumberOfCombinations(selectionsCount, system);
        return (maxWin +
            multiply(multiply(odds[system - 1], stakePerCombination), systemCombinations));
    }, 0);
}
function calculateLottoMinPotentialWin(systems, odds, stakePerCombination) {
    var minSystem = Math.min.apply(Math, __spreadArray([], __read(systems)));
    return multiply(odds[minSystem - 1], stakePerCombination);
}
function getZeroWin(taxBrackets, taxMode, rounding) {
    return {
        taxes: {
            totalTax: 0,
            brackets: totalTaxToBrackets(0, taxBrackets, taxMode, rounding),
        },
        net: 0,
        base: 0,
        bonus: 0,
        gross: 0,
    };
}
function getZeroPayout(_a) {
    var amount = _a.amount, handlingFee = _a.handlingFee, taxBrackets = _a.taxBrackets, taxMode = _a.taxMode, rounding = _a.rounding, recommendStake = _a.recommendStake;
    var roundedAmount = round(amount, rounding);
    return {
        combinations: 0,
        stake: __assign({ amount: roundedAmount, handlingFee: round(handlingFee, rounding), stakePerCombination: roundedAmount }, (recommendStake && { recommendedStake: roundedAmount })),
        maxWin: getZeroWin(taxBrackets, taxMode, rounding),
        minWin: getZeroWin(taxBrackets, taxMode, rounding),
        hasBeenLimited: false,
    };
}

function calculateLottoPayout(numbersDrawn, selectionsCount, systems, odds, grossStake, config, callback) {
    try {
        var calculatedPayout = _calculateLottoPayout(numbersDrawn, selectionsCount, systems, odds, grossStake, config);
        if (!callback) {
            return calculatedPayout;
        }
        callback(null, calculatedPayout);
    }
    catch (e) {
        if (!callback) {
            throw e;
        }
        callback(e);
    }
}
function _calculateLottoPayout(numbersDrawn, selectionsCount, systems, odds, grossStake, config) {
    if (grossStake < 0) {
        throw new Error('grossStake must be >= 0');
    }
    if (selectionsCount < 0) {
        throw new Error('selectionsCount must be >= 0');
    }
    if (!systems) {
        throw new Error('systems must be provided to calculateLottoPayout');
    }
    // TODO: more validation?
    var isSystem = isSystemTicket(selectionsCount, systems);
    var amountsRounding = config.rounding.amounts;
    var stakeCalculationsRounding = isSystem
        ? config.rounding.stakeCalculations.system
        : config.rounding.stakeCalculations.simple;
    var calculatedStake = calculateStake(grossStake, config.handlingFeeRate, config.handlingFeeInverse, stakeCalculationsRounding);
    // for calculation purposes the selectionsCount can't be over the given odds length
    var selectionsOddsMin = Math.min(selectionsCount, odds.length);
    if (!selectionsOddsMin || (!isSystem && odds.length < selectionsCount)) {
        return getZeroPayout({
            amount: calculatedStake.amount,
            taxMode: config.taxMode,
            taxBrackets: config.taxBrackets,
            rounding: amountsRounding,
            handlingFee: calculatedStake.handlingFee,
            recommendStake: config.recommendStake
        });
    }
    // for calculation purposes turn the 'simple' lotto ticket in to x/x system ticket
    if (!isSystem) {
        systems = [selectionsOddsMin];
    }
    // filter out all systems which are higher than the selectionsOddsMin (this is an invalid input)
    systems = systems.filter(function (system) { return system <= selectionsOddsMin; });
    var combinations = systemsNumberOfCombinations(selectionsCount, systems);
    var stakePerCombination = calculateStakePerCombination(calculatedStake.amount, combinations, config.rounding.stakeCalculations.perCombination);
    var taxBase = config.taxBase, taxBrackets = config.taxBrackets;
    var taxConfig = {
        taxMode: config.taxMode,
        totalTaxDecimals: config.rounding.tax.total,
        bracketTaxDecimals: config.rounding.tax.brackets,
        maxTax: getMaxTax(config.maxWin, config.taxBrackets),
    };
    // calculate max potential win
    var unlimitedGrossMax = calculateLottoMaxPotentialWin(Math.min(selectionsCount, numbersDrawn), systems, odds, stakePerCombination);
    var maxGross = round(limitWin(unlimitedGrossMax, config.maxWin), amountsRounding);
    var maxTaxes = calculateTaxesPerTicket({
        gross: maxGross,
        netStake: calculatedStake.amount,
        taxBase: taxBase,
        taxBrackets: taxBrackets,
        taxConfig: taxConfig,
    });
    var maxNet = getNet(maxGross, maxTaxes.totalTax, amountsRounding);
    // if recommendStake flag is true, calculate the recommendedStake
    var maxWinRecommendedStake = {};
    if (config.recommendStake) {
        Object.assign(maxWinRecommendedStake, {
            recommendedStake: calculateRecommendedStake(grossStake, unlimitedGrossMax, config.maxWin),
        });
    }
    // calculate min potential win
    var minGross = round(limitWin(calculateLottoMinPotentialWin(systems, odds, stakePerCombination), config.maxWin), amountsRounding);
    var minTaxes = calculateTaxesPerTicket({
        gross: minGross,
        netStake: calculatedStake.amount,
        taxBase: taxBase,
        taxBrackets: taxBrackets,
        taxConfig: taxConfig,
    });
    var minNet = getNet(minGross, minTaxes.totalTax, amountsRounding);
    return {
        combinations: combinations,
        stake: __assign({ amount: round(calculatedStake.amount, amountsRounding), handlingFee: round(calculatedStake.handlingFee, amountsRounding), stakePerCombination: round(stakePerCombination, amountsRounding) }, maxWinRecommendedStake),
        maxWin: {
            taxes: maxTaxes,
            net: maxNet,
            base: maxGross,
            bonus: 0,
            gross: maxGross,
        },
        minWin: {
            taxes: minTaxes,
            net: minNet,
            base: minGross,
            bonus: 0,
            gross: minGross,
        },
        hasBeenLimited: unlimitedGrossMax > config.maxWin,
    };
}

function isLuckyLoserEligible(config, ticketType, selections, isSport, isSimple) {
    if (ticketType !== TicketType.retail || !isSport || !isSimple) {
        return false;
    }
    var luckyLoserPerLossConfigs = Object.values(config);
    return luckyLoserPerLossConfigs.some(function (perLossConfig) { return isLuckyLoserEligibleForConfig(perLossConfig, selections); });
}
function isLuckyLoserEligibleForConfig(config, selections) {
    var minOddValue = config.minOddValue, minOddCount = config.minOddCount, minTicketCoefficient = config.minTicketCoefficient, ignoredOfferTypes = config.ignoredOfferTypes, excludedMarketsByTag = config.excludedMarketsByTag;
    if (selections.some(function (selection) { return ((selection.marketType.kind === OfferType.Base && selection.marketType.selectionType === SelectionType.live)) ||
        (selection.marketType.kind === OfferType.SuperOffer && ignoredOfferTypes.includes(selection.marketType.offerType)) ||
        (excludedMarketsByTag.some(function (tag) { return selection.tags.includes(tag); })); })) {
        return false;
    }
    if (selections.length < minOddCount) {
        return false;
    }
    var selectionOdds = selections.map(function (selection) { return selection.odd; });
    if (selectionOdds.some(function (odd) { return odd < minOddValue; })) {
        return false;
    }
    var totalOdd = selectionOdds.reduce(function (acc, odd) { return acc = acc * odd; }, 1);
    if (totalOdd < minTicketCoefficient) {
        return false;
    }
    return true;
}

var BonusType;
(function (BonusType) {
    BonusType["SuperBonus"] = "SuperBonus";
})(BonusType || (BonusType = {}));

export { BonusSelection, BonusType, NotEligibleReason, OfferType, SelectionType, SuperBonusCalculationBase, SuperBonusValidBetTypes, SuperOffer, TaxBase, TaxMode, TicketType, calculateLottoPayout, calculateLottoSystemWinPerBall, calculateSportPayout, calculateStake, calculateStakePerCombination, calculateBonus as calculateSuperBonus, calculateTaxes, getNumberOfCombinationsForSystem, getTaxBrackets, getTaxableAmount, isLuckyLoserEligible, isSuperBonusEligible, parseSuperBonusBreakpoints, totalTaxToBrackets };
//# sourceMappingURL=index.esm.js.map
